<template>
    <section class="relative" role="banner" aria-label="Hero section">
        <div class="relative 3xl:h-[800px] xl:h-[700px] lg:h-[600px] 2xl:h-[800px]">
          <nuxt-img 
                :src="props.largeDesktopImageSrc" 
                :alt="props.desktopImageAlt"
                format="webp"
                loading="eager"
                :img-attrs="{ fetchpriority: 'high' }"
                class="hidden object-cover object-bottom w-full h-full 2xl:block" 
                width="1920"
                height="800"
                fetchpriority="high"
                preload
                sizes="xs:340px sm:440px md:716px lg:1024px xl:1200px 2xl:1920px"
            />

            <nuxt-img 
                :src="props.desktopImageSrc" 
                :alt="props.desktopImageAlt"
                format="webp"
                loading="eager"
                :img-attrs="{ fetchpriority: 'high' }"
                class="hidden object-cover object-bottom w-full h-full md:block 2xl:hidden" 
                width="1920"
                height="1123"
                fetchpriority="high"
                preload
                sizes="xs:340px sm:440px md:716px lg:1024px xl:1200px 2xl:1920px"
            />

            <nuxt-img 
                :src="props.mobileImageSrc" 
                :alt="props.mobileImageAlt"
                format="webp"
                loading="eager"
                :img-attrs="{ fetchpriority: 'high' }"
                class="object-cover w-full h-full md:hidden" 
                width="618"
                height="1104"
                fetchpriority="high"
                preload
                sizes="xs:340px sm:440px md:716px lg:618px xl:618px"
            /> 

        </div>
        <div class="absolute inset-0 z-10">
            <div
                class="flex top-0 z-20 flex-wrap gap-x-2 gap-y-2 justify-between items-center px-3 pt-2 mx-auto w-full max-w-screen-2xl md:pt-4 lg:px-6 sm:px-6">
                <div class="relative">
                    <a href="/" aria-label="Lifeboost Coffee Homepage">

                        <svg class="object-contain relative z-10 w-28 md:w-40" width="163" height="60" viewBox="0 0 163 60" fill="none"
                            xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Lifeboost Coffee Logo">
                            <path d="M46.2736 20.3906H43.8984V40.4763H46.2736V20.3906Z" fill="white" />
                            <path d="M32.4025 20.3906H30.0273V40.4763H40.3808V39.3435H32.4025V20.3906Z" fill="white" />
                            <path
                                d="M85.1029 29.8184C86.2966 29.2459 87.4537 28.6612 88.2333 27.5406C89.6706 25.4577 89.1956 22.3882 86.8691 21.2189C85.2612 20.415 83.4463 20.3906 81.6924 20.3906H76.5156V40.4763C80.1211 40.4763 84.4086 41.1219 87.5877 39.0634C89.9751 37.5165 90.5111 33.7283 88.5865 31.5845C87.673 30.5614 86.3697 30.1716 85.1029 29.8184ZM78.8908 21.5356C79.9993 21.5356 81.0955 21.5843 82.2039 21.633C83.2636 21.6818 84.3843 21.6939 85.31 22.3151C87.3198 23.6672 86.7229 27.1508 84.8958 28.3567C83.1662 29.5017 80.8641 29.2946 78.8908 29.2946V21.5356ZM85.8215 38.3447C83.9701 39.6724 81.0346 39.3435 78.8908 39.3435V30.5492C80.9859 30.5492 83.4342 30.2447 85.31 31.3896C87.5025 32.7295 88.0506 36.7491 85.8215 38.3447Z"
                                fill="white" />
                            <path
                                d="M63.2539 40.4763H73.5099V39.3435H65.6413V30.6466H72.6816V29.4042H65.6413V21.5356H73.5099V20.3906H63.2539V40.4763Z"
                                fill="white" />
                            <path
                                d="M50.3086 40.5818H52.6838V30.7521H59.7241V29.5097H52.6838V21.6411H60.5524V20.4961H50.3086V40.5818Z"
                                fill="white" />
                            <path
                                d="M31.8384 12.6348C31.8384 12.2328 31.4852 12.0745 31.1563 11.977C30.4498 11.7699 29.7068 11.636 28.9882 11.502C27.9163 11.2827 26.8566 11.0757 25.7847 10.8929C25.2853 10.8077 24.591 10.7955 24.1525 10.5397C23.6409 10.2474 23.4095 9.38256 23.0441 8.9197C22.1792 7.82345 20.9003 7.1048 19.4752 7.1657C18.1475 7.21442 16.832 7.77473 15.7479 8.52992C15.3825 8.78571 14.4081 9.50436 15.1511 9.95504C15.7601 10.3205 16.7833 9.23639 17.307 8.95624C18.8296 8.14014 20.5714 7.9818 21.8504 9.34602C22.2158 9.73579 22.5203 10.2108 22.7639 10.6859C22.9101 10.9538 22.9953 11.3314 23.2511 11.5142C23.6531 11.8065 24.3839 11.7821 24.859 11.8674C26.1136 12.0988 27.4169 12.4886 28.6837 12.5495C26.9418 13.0733 24.9808 12.9271 23.2024 13.2194C22.362 13.3534 21.6311 13.865 20.8272 14.0964C20.072 14.3157 19.2437 14.4131 18.72 13.6823C18.2449 13.0002 18.4155 11.3071 19.5726 11.5629C20.1329 11.6847 20.2182 12.5251 20.815 12.513C21.1926 12.5008 21.3388 12.1597 21.2901 11.8308C21.2292 11.3314 20.8394 10.8686 20.4009 10.6372C20.1451 10.5032 19.8528 10.4301 19.5726 10.4057C16.7955 10.1743 16.5275 14.6324 18.9514 15.2779C20.5592 15.7043 21.8382 14.7785 23.2999 14.3766C23.7993 14.2304 24.3474 14.2548 24.8468 14.1939C26.2232 14.0233 27.6118 13.8894 28.9882 13.7066C29.7068 13.6092 30.462 13.5483 31.1563 13.3412C31.4852 13.2072 31.8384 13.0245 31.8384 12.6348Z"
                                fill="white" />
                            <path d="M139.566 20.3906V21.5356H145.766V40.4763H148.154V21.5356H154.256V20.3906H139.566Z"
                                fill="white" />
                            <path
                                d="M129.284 26.505C127.652 24.1663 129.552 21.4135 132.098 21.0481C133.28 20.8776 134.595 21.0603 135.716 21.4379C136.313 21.6449 136.873 21.9738 137.47 22.1565C137.47 21.8155 137.543 21.3404 137.36 21.0359C137.19 20.7558 136.824 20.6461 136.532 20.5243C135.691 20.1711 134.839 19.9762 133.95 19.8422C130.965 19.4159 127.53 20.9263 126.921 24.1176C126.8 24.7875 126.751 25.5062 126.848 26.1883C127.275 29.1603 129.881 30.3296 132.39 31.3406C134.047 32.0106 135.813 32.7292 136.605 34.471C137.713 36.9315 136.008 39.3554 133.535 39.9157C131.051 40.476 128.834 39.6965 126.702 38.515C126.702 38.8926 126.617 39.4041 126.812 39.733C126.994 40.0497 127.421 40.2324 127.738 40.3786C128.529 40.744 129.358 40.9876 130.222 41.146C133.353 41.6941 137.336 40.6953 138.542 37.3822C138.797 36.6879 138.931 35.9449 138.919 35.214C138.907 34.6172 138.81 34.0204 138.639 33.46C137.36 29.0994 131.623 29.8424 129.284 26.505Z"
                                fill="white" />
                            <path
                                d="M22.5462 16.7726C22.4 16.4194 22.0346 16.1514 21.6692 16.4315C21.1941 16.8091 21.657 17.8445 21.7666 18.3195C22.132 20.037 22.4609 21.8397 22.4609 23.5937C22.4609 27.4549 20.9383 31.2796 17.6009 33.4234C16.1879 34.3369 14.6532 34.7754 13.0453 35.1896C16.8091 28.8191 17.9663 20.9627 14.9212 14.0685C13.3499 10.5118 10.9016 7.3814 8.07569 4.73823C6.90636 3.65416 5.71267 2.63099 4.45807 1.64437C3.70288 1.07189 2.93551 0.414138 2.07069 0C0.621207 2.3752 0 5.31071 0 8.07569C0 13.496 2.04633 18.4535 5.42034 22.668C6.8211 24.422 8.35584 26.0298 10.0368 27.5036C10.4387 27.8569 10.8407 28.2467 11.2792 28.5512C11.4497 28.673 11.6446 28.807 11.8638 28.6852C12.1318 28.5268 12.2414 28.1005 12.3389 27.8447C12.6921 26.9433 12.8505 26.0054 12.9723 25.0554C13.5448 20.6095 11.5106 16.2488 8.83089 12.8383C8.01479 11.8029 7.11343 10.731 6.10245 9.87841C5.79793 9.62262 5.23763 9.08668 4.83567 9.50081C4.40935 9.92713 4.99402 10.4753 5.27417 10.7676C6.23643 11.742 7.19869 12.6921 8.05133 13.764C10.999 17.5034 12.8992 22.4 11.3888 27.1139C9.05014 24.7874 6.69929 22.6192 4.83567 19.8664C2.54573 16.4803 0.852637 12.1318 1.03535 7.96607C1.13279 5.77357 1.65655 3.66634 2.48483 1.65655C4.75041 3.45927 7.04035 5.20109 8.98923 7.34486C13.5326 12.3632 16.395 18.6119 15.384 25.4573C15.1039 27.3575 14.5436 29.282 13.7884 31.0482C12.9114 33.1189 11.8638 35.2017 10.5605 37.0532C8.90397 39.404 7.02817 41.4869 5.59086 43.9839C4.93312 45.1289 4.43371 46.4078 4.20228 47.7111C4.1292 48.1131 3.99521 48.8683 4.25101 49.2337C4.47026 49.5504 4.96966 49.4895 5.11582 49.1484C5.3838 48.5272 5.32289 47.6624 5.54214 46.9925C6.005 45.5674 6.7602 44.2032 7.58847 42.9607C8.67254 41.3285 9.92713 39.8547 11.1086 38.3078C11.5106 37.784 11.9004 36.7974 12.4607 36.4442C12.7896 36.2371 13.3864 36.2493 13.764 36.1762C14.5801 36.0178 15.3718 35.7864 16.1392 35.4697C19.4767 34.142 21.9371 31.5232 22.9238 28.0518C23.7399 25.1893 23.6424 22.0468 23.0699 19.1478C22.9359 18.3804 22.8385 17.5156 22.5462 16.7726Z"
                                fill="white" />
                            <path
                                d="M124.497 24.8488C123.096 21.3895 119.563 19.2823 115.848 19.8183C115.032 19.9401 114.216 20.1228 113.473 20.476C109.234 22.4614 108.199 27.4311 108.491 31.6821C108.589 33.095 108.747 34.4958 109.271 35.8235C110.647 39.2949 113.985 41.7554 117.822 41.2803C118.601 41.1829 119.369 40.988 120.099 40.6835C124.679 38.7833 125.849 33.3386 125.398 28.8806C125.252 27.5042 125.02 26.1521 124.497 24.8488ZM119.685 39.1C119.064 39.4045 118.394 39.5264 117.724 39.6116C115.093 39.9649 112.755 38.6737 111.707 36.2376C111.195 35.0317 110.976 33.7041 110.879 32.4007C110.623 28.8927 110.745 23.8135 114.411 21.9864C114.984 21.6941 115.641 21.5601 116.275 21.4748C119.076 21.0728 121.5 22.8756 122.377 25.47C122.706 26.4201 122.913 27.3702 123.011 28.369C123.071 29.0633 123.108 29.7332 123.108 30.4397C123.096 33.4604 122.779 37.5653 119.685 39.1Z"
                                fill="white" />
                            <path
                                d="M106.542 25.3608C105.239 21.6823 101.804 19.2462 97.8331 19.8186C97.017 19.9404 96.201 20.1232 95.4579 20.4764C91.1704 22.4862 90.1594 27.8091 90.5735 32.0966C90.6953 33.3634 90.8659 34.6302 91.3409 35.8239C92.693 39.2588 95.9817 41.7923 99.8064 41.2686C100.562 41.1711 101.28 41.0006 101.987 40.7083C106.323 38.8568 107.565 33.9237 107.273 29.6118C107.163 28.1501 107.042 26.7615 106.542 25.3608ZM101.975 38.8812C101.244 39.3319 100.428 39.5024 99.5993 39.612C96.6029 40.0261 94.2155 38.1747 93.2898 35.4097C92.9975 34.5327 92.8513 33.6314 92.7539 32.7178C92.3763 29.1733 92.6564 23.7773 96.3958 21.999C96.9927 21.7188 97.6139 21.5726 98.2595 21.4752C101.171 21.0611 103.461 23.0343 104.338 25.6775C104.654 26.6276 104.8 27.5776 104.91 28.5764C104.983 29.2707 104.995 29.9528 104.995 30.6471C104.983 33.4608 104.642 37.249 101.975 38.8812Z"
                                fill="white" />
                            <path d="M157.338 20.9747H156.266V20.3535H159.104V20.9747H158.032V23.7153H157.338V20.9747Z"
                                fill="white" />
                            <path
                                d="M163 20.292V23.7147H162.318V21.9242L161.465 22.9839H161.246L160.405 21.9242V23.7147H159.711V20.292H159.942L161.355 22.1069L162.78 20.292H163Z"
                                fill="white" />
                            <path
                                d="M72.4004 53.3138C73.4114 53.3138 74.264 53.801 74.7756 54.5684L74.13 55.0921C73.6671 54.4709 73.0825 54.1543 72.4126 54.1543C71.2189 54.1543 70.3175 55.1287 70.3175 56.3224C70.3175 57.5283 71.2189 58.5027 72.4126 58.5027C73.0825 58.5027 73.655 58.1982 74.1178 57.577L74.7634 58.0886C74.2396 58.8559 73.3992 59.3432 72.4004 59.3432C70.7316 59.3432 69.3796 57.9911 69.3796 56.3224C69.3431 54.6658 70.756 53.2894 72.4004 53.3138Z"
                                fill="white" />
                            <path
                                d="M80.0527 53.3142C81.6971 53.2898 83.11 54.6784 83.0735 56.3228C83.11 57.9428 81.6849 59.3679 80.0405 59.3314C78.3962 59.3679 77.0076 57.9428 77.0319 56.3228C76.9954 54.6662 78.3962 53.2776 80.0527 53.3142ZM80.0527 54.1546C78.8712 54.1546 77.9698 55.0925 77.9698 56.335C77.9698 57.5408 78.8712 58.4909 80.0405 58.4909C81.2099 58.4909 82.1356 57.5408 82.1356 56.335C82.1356 55.0804 81.2221 54.1546 80.0527 54.1546Z"
                                fill="white" />
                            <path
                                d="M86.9567 53.4358H88.4061V54.2519H86.9567V59.1972H86.0431V54.2519H85.2148V53.4358H86.0431V52.0594C86.0431 50.7926 86.774 50.1836 87.9433 50.1836C88.1869 50.1836 88.4427 50.2201 88.6619 50.281V51.0484C88.4671 51.0241 88.3087 51.0119 88.1504 51.0119C87.383 51.0119 86.9445 51.292 86.9445 52.1081V53.4358H86.9567Z"
                                fill="white" />
                            <path
                                d="M91.4254 53.4358H92.8749V54.2519H91.4254V59.1972H90.5119V54.2519H89.6836V53.4358H90.5119V52.0594C90.5119 50.7926 91.2427 50.1836 92.412 50.1836C92.6556 50.1836 92.9114 50.2201 93.1307 50.281V51.0484C92.9358 51.0241 92.7775 51.0119 92.6191 51.0119C91.8517 51.0119 91.4132 51.292 91.4132 52.1081V53.4358H91.4254Z"
                                fill="white" />
                            <path
                                d="M95.7426 56.6022C95.8522 57.735 96.7292 58.4902 97.862 58.4902C98.5076 58.4902 99.1044 58.2344 99.6282 57.7106L100.164 58.3319C99.5551 58.9531 98.7634 59.3428 97.862 59.3428C96.1446 59.3428 94.8047 58.0273 94.8047 56.3342C94.8047 54.6655 96.108 53.3135 97.7524 53.3135C99.2384 53.3135 100.383 54.3854 100.383 55.9201C100.383 56.1394 100.359 56.3708 100.31 56.6022H95.7426ZM99.4333 55.7983C99.4211 54.763 98.6781 54.1418 97.7158 54.1418C96.7536 54.1418 95.974 54.7995 95.7791 55.7983H99.4333Z"
                                fill="white" />
                            <path
                                d="M103.743 56.6022C103.853 57.735 104.73 58.4902 105.862 58.4902C106.508 58.4902 107.105 58.2344 107.629 57.7106L108.165 58.3319C107.556 58.9531 106.764 59.3428 105.85 59.3428C104.133 59.3428 102.793 58.0273 102.793 56.3342C102.793 54.6655 104.096 53.3135 105.741 53.3135C107.227 53.3135 108.372 54.3854 108.372 55.9201C108.372 56.1394 108.347 56.3708 108.299 56.6022H103.743ZM107.434 55.7983C107.422 54.763 106.679 54.1418 105.716 54.1418C104.754 54.1418 103.974 54.7995 103.78 55.7983H107.434Z"
                                fill="white" />
                        </svg>

                    </a>

                </div>
                <div class="flex z-20 gap-x-3 items-center">
                    <a href="tel:1-800-479-1596"
                        class="hidden gap-2 items-center px-6 py-2 text-base font-bold rounded-full border transition md:block border-lifeboost-green-400 text-lifeboost-green-400 sm:py-2.5"
                        aria-label="Call us at 1-800-479-1596">

                        <span class="contents">
                            {{ props.phoneNumber }}</span>
                    </a>

                    <button
                    @click="scrollTo(props.buttonHref,'bottom')"
                        class="flex gap-x-2 items-center px-4 py-2 mx-auto text-base font-bold rounded-full transition-colors duration-200 xs-max:text-sm bg-lifeboost-green-400 lg:px-8 font-ww-medium sm:px-6 sm:py-2.5"
                        :aria-label="props.ctaButtonText">

                        {{ props.ctaButtonText }}
                    </button>
                </div>
            </div>

            <div class="grid relative z-10 px-4 mx-auto my-auto mt-4 max-w-6xl h-full md:items-center lg:-mt-48 md:-mt-32 xl:max-w-7xl lg:px-6">
               <div class="grid grid-cols-12">
               <div class="col-span-12 md:col-span-7 lg:col-span-6">
                <h1 class="text-3xl text-center text-white xl:text-51 xl:!leading-none md:text-4xl font-ww-bold md:text-left">
                    <span v-html="props.mainTitle"></span>
                </h1>

                <div class="xl:text-[90px] mt-2 md:text-7xl sm:text-6xl text-5xl md:text-left w-fit mx-auto md:mx-0 text-center leading-none font-ww-bold text-lifeboost-green-400 relative">
                    {{ props.highlightText }}

                    <span class="absolute left-0 -bottom-4 xl:-bottom-5" aria-hidden="true">
                        <svg class="w-52 sm:w-72 xl:w-full" width="354" height="13" viewBox="0 0 354 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M354 0H0V13L354 0Z" fill="#D2F06F"/>
</svg>

                    </span>
                </div>

               </div>
               </div>
              
            </div>

        </div>
    </section>
</template>

<script setup>
// Props
const props = defineProps({
  largeDesktopImageSrc: {
    type: String,
    default: '/assets/images/mindflow-big-hero.jpg'
  },
  desktopImageSrc: {
    type: String,
    default: '/assets/images/mindflow-hero-new-cut.png'
  },
  desktopImageAlt: {
    type: String,
    default: 'Lifeboost Mindflow Coffee Hero Image'
  },
  mobileImageSrc: {
    type: String,
    default: '/assets/images/hero-new-112.png'
  },
  mobileImageAlt: {
    type: String,
    default: 'Lifeboost Mindflow Coffee Hero Image Mobile'
  },
  mainTitle: {
    type: String,
    default: 'What If You\'ve <br>Been Using Caffeine'
  },
  highlightText: {
    type: String,
    default: 'All Wrong?'
  },
  phoneNumber: {
    type: String,
    default: '1-800-479-1596'
  },
  ctaButtonText: {
    type: String,
    default: 'Try It Risk-Free Today'
  },
  buttonHref: {
    type: String,
    default: '#cta'
  }
})

defineBuilderComponent({
  friendlyName: 'Hero Section with Background Image',
  inputs: [
    {
      name: 'largeDesktopImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      defaultValue: '/assets/images/mindflow-big-hero.jpg'
    },
    {
      name: 'desktopImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      defaultValue: '/assets/images/mindflow-hero-new-cut.png'
    },
    {
      name: 'desktopImageAlt',
      type: 'text',
      defaultValue: 'Lifeboost Mindflow Coffee Hero Image'
    },
    {
      name: 'mobileImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      defaultValue: '/assets/images/hero-new-112.png'
    },
    {
      name: 'mobileImageAlt',
      type: 'text',
      defaultValue: 'Lifeboost Mindflow Coffee Hero Image Mobile'
    },
    {
      name: 'mainTitle',
      type: 'richText',
      defaultValue: 'What If You\'ve <br>Been Using Caffeine'
    },
    {
      name: 'highlightText',
      type: 'text',
      defaultValue: 'All Wrong?'
    },
    {
      name: 'phoneNumber',
      type: 'text',
      defaultValue: '1-800-479-1596'
    },
    {
      name: 'ctaButtonText',
      type: 'text',
      defaultValue: 'Try It Risk-Free Today'
    },
    {
      name: 'buttonHref',
      type: 'text',
      defaultValue: '#cta'
    }
  ]
})
</script>
